export interface AiAdministrationConfiguration {
    welcomeCreditEur: number;
    monthlySpendingLimitEur: number | null;
    currentMonthlySpendingEur: number;
    currentMonthlySpendingBreakdown: AiSpendingBreakdown;
    welcomeCreditSpendingBreakdown: AiSpendingBreakdown;
    hasWelcomeCreditBeenExhausted: boolean;
    showWelcomeBox: boolean;
}

export interface AiSpendingBreakdown {
    contractCreation: number;
    obligationExtraction: number;
    qualityScanOfDocuments: number;
    chat: number;
}

export enum AiSpendingStatus {
    None = 0,
    AlmostExhausted = 1,
    FullyExhausted = 2,
}

export interface AiSpendingWarning {
    status: AiSpendingStatus;
    hasMonthlySpendingLimit: boolean;
}

export function isAiSpendingExhausted(warning: AiSpendingWarning | undefined): boolean {
    return warning?.status === AiSpendingStatus.FullyExhausted;
}
